<div class="card">
  <div class="card-header d-flex align-tems-center justify-content-between">
    <div>
      <button class="btn btn-light btn-sm" (click)="expanded = !expanded">
        @if (expanded) {
        <span class="dripicons-chevron-up"></span>
        }
        @if (!expanded) {
        <span class="dripicons-chevron-down"></span>
        }
      </button>
      Collection Setup
    </div>
    <button class="btn btn-sm btn-primary float-right" (click)="save()" [disabled]="loading || form.invalid || !entityId">
      Save
    </button>
  </div>
  @if (expanded) {
  <div>
    <div class="card-body">
      <form [formGroup]="form" id="collection-setup-defaults">
        <div class="row text-dark">
          <div class="col-md-6 col-sm-12">
            <div class="container">
              <div class="form-group form-row">
                <label for="receiptStartingNumber" class="col col-form-label">Starting Receipt Number</label>
                <div class="col"><number-input [id]="'receiptStartingNumber'" [control]="form.get('receiptStartingNumber')"></number-input></div>
              </div>
              <div class="form-group form-row">
                <label for="defaultCollectionMethod" class="col col-form-label">Default Collection Method</label>
                <div class="col">
                  <select class="form-select form-control form-control-sm" id="defaultCollectionMethod" formControlName="defaultCollectionMethod">
                    <option value="Scheduled Installment Earnings">Scheduled Installment Earnings</option>
                    <option value="True Daily Earnings">True Daily Earnings</option>
                  </select>
                </div>
              </div>
              <h5 class="mid-section">Late Fee Setup</h5>
              <div class="form-group form-row">
                <label class="form-check-label col" for="enableLateFees">Enable Late Fees</label>
                <input type="checkbox" id="enableLateFees" class="form-check-input col" formControlName="enableLateFees" />
              </div>
              <div class="form-group form-row">
                <label class="form-check-label col" for="allowWaiveLateFee">Allow Waive Late Fee</label>
                <input type="checkbox" id="allowWaiveLateFee" class="form-check-input col" formControlName="allowWaiveLateFee" />
              </div>
              <div class="form-group form-row">
                <label for="lateFeeMethod" class="col col-form-label">Late Fee Method</label>
                <div class="col">
                  <select class="form-select form-control form-control-sm" id="lateFeeMethod" formControlName="lateFeeMethod">
                    <option value="scheduled">Scheduled Payment Amount</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="lateFeePercent" class="col col-form-label">Default Late Fee Percent</label>
                <div class="col"><percent-input [id]="'lateFeePercent'" [control]="form.get('lateFeePercent')"></percent-input></div>
              </div>
              <div class="form-group form-row">
                <label for="daysLateTolerance" class="col col-form-label">Days Late Tolerance</label>
                <div class="col"><count-input [id]="'daysLateTolerance'" [control]="form.get('daysLateTolerance')"></count-input></div>
              </div>
              <div class="form-group form-row">
                <label for="amountLateTolerance" class="col col-form-label">Amount Late Tolerance</label>
                <div class="col"><currency-input [id]="'amountLateTolerance'" [control]="form.get('amountLateTolerance')"></currency-input></div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="container allocation">
              <h5>Payment Allocation Order</h5>
              <small>
                Click and hold on the category to drag and drop in the desired order.
                The initial down payment cannot be reordered.
              </small>
              <div cdkDropList [cdkDropListData]="paymentAllocationData" class="allocation-list" (cdkDropListDropped)="drop($event)">
                @for (category of paymentAllocationData; track category) {
                <div class="allocation-item" cdkDrag [cdkDragDisabled]="!category.draggable">
                  <p>{{category.name}}</p>
                  <span class="dripicons-view-apps" [ngClass]="{'d-none' : !category.draggable}"></span>
                </div>
                }
              </div>
              <div class="button-panel">
                <button class="btn btn-sm btn-primary" (click)="resetDefaultPaymentAllocationOrder()">Reset to System Default</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  }
</div>